import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "m16.016 17.05-5.754-5.754q-.75.62-1.725.97t-2.017.35q-2.564 0-4.34-1.776T.404 6.5q0-2.562 1.776-4.34Q3.955.385 6.518.385t4.34 1.775q1.777 1.775 1.777 4.34 0 1.071-.36 2.046t-.96 1.696l5.78 5.779a.65.65 0 0 1 .195.513.75.75 0 0 1-.22.516.72.72 0 0 1-.527.217.72.72 0 0 1-.527-.217M6.52 11.115q1.933 0 3.274-1.341T11.135 6.5 9.794 3.226 6.52 1.884 3.246 3.226Q1.904 4.566 1.904 6.5t1.342 3.274 3.274 1.341m0-1.923a.73.73 0 0 1-.535-.215.73.73 0 0 1-.215-.535V7.25H4.552a.69.69 0 0 1-.517-.216.74.74 0 0 1-.208-.534q0-.32.216-.535a.73.73 0 0 1 .534-.215H5.77V4.533q0-.31.215-.518a.74.74 0 0 1 .535-.207q.319 0 .534.215a.73.73 0 0 1 .216.535V5.75h1.217q.31 0 .517.216a.74.74 0 0 1 .208.534q0 .319-.216.534a.73.73 0 0 1-.534.216H7.27v1.217a.69.69 0 0 1-.216.517.74.74 0 0 1-.535.208"
    }, null, -1)
  ])))
}
export default { render: render }